import { Card, CardContent, CardHeader, CircularProgress, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonTypography from 'components/ArgonTypography';
import { CustomDescrypt } from 'global/func';
import { postDataWithResponse } from 'global/postFunc';
import React, { useEffect, useState } from 'react'
import { decodeToken } from 'react-jwt';
import userStore from 'store/userStore';

const getPersenRealisasi = (realisasi, anggaran) => {
    let output = 0;
    if (anggaran === 0) {
        output = 0;
    }
    else {
        output = (realisasi / anggaran)
    }
    return output;
}

const StrukturAnggaran = () => {
    const { user, addReq, tahunAnggaran } = userStore(state => ({ user: state.user, addReq: state.addReq, tahunAnggaran: state.tahunAnggaran }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));
    const decodedUser = decodeToken(decryptedUser)
    
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        reqStrukturAnggaran()
        console.log(data);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const reqStrukturAnggaran = () => {
        addReq()
        setLoading(true)
        postDataWithResponse(
            '/admin-opd/struktur-anggaran',
            {
                kd_pd: decodedUser.kd_pd,
                ta: tahunAnggaran.ta
            },
            decryptedUser,
            (res) => {
                setData(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }
    
    return (
        <ArgonBox py={3}>
            <ArgonBox mb={3}>
                <Card>
                    <CardContent>
                        <Table aria-label="simple table">
                            <TableBody>
                                <TableRow key={0} >
                                    <TableCell sx={{ fontSize: 'small' }}>Perangkat Daerah</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {decodedUser.kd_pd} {decodedUser.nm_pd}</TableCell>
                                </TableRow>
                                <TableRow key={1} >
                                    <TableCell sx={{ fontSize: 'small' }}>Tahun Anggaran</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>: {tahunAnggaran.ta}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </CardContent>
                </Card>
            </ArgonBox>
            
            <ArgonBox mb={3}>
                <Card>
                    <CardHeader
                        title={
                            <ArgonTypography variant='h6'>Struktur Anggaran</ArgonTypography>
                        }
                    />
                    <CardContent>
                        {
                            loading ?
                                (
                                    <ArgonBox align="center">
                                        <CircularProgress />
                                    </ArgonBox>
                                )
                                :
                                (
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ fontSize: 'small' }}>No</TableCell>
                                                <TableCell sx={{ fontSize: 'small' }}>Uraian</TableCell>
                                                <TableCell sx={{ fontSize: 'small' }}>Anggaran</TableCell>
                                                <TableCell sx={{ fontSize: 'small' }}>Realisasi Keuangan</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                data.map((dt, index) => (
                                                    <TableRow key={index} >
                                                        <TableCell sx={{ fontSize: 'small', fontWeight: (dt.ket === 'KELOMPOK' || dt.ket === 'AKUN') && 'bold' }}>{dt.kode}</TableCell>
                                                        <TableCell sx={{ fontSize: 'small', fontWeight: (dt.ket === 'KELOMPOK' || dt.ket === 'AKUN') && 'bold' }}>
                                                            {dt.ket === 'KELOMPOK' ? <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> : dt.ket === 'JENIS' && <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> }{dt.uraian}
                                                        </TableCell>
                                                        <TableCell sx={{ fontSize: 'small', fontWeight: (dt.ket === 'KELOMPOK' || dt.ket === 'AKUN') && 'bold' }}>{dt.anggaran?.toLocaleString?.('id-ID', {
                                                            style: 'currency',
                                                            currency: 'IDR',
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0,
                                                        })}</TableCell>
                                                        <TableCell sx={{ fontSize: 'small', fontWeight: (dt.ket === 'KELOMPOK' || dt.ket === 'AKUN') && 'bold' }}>
                                                            {dt.ru?.toLocaleString?.('id-ID', {
                                                                style: 'currency',
                                                                currency: 'IDR',
                                                                minimumFractionDigits: 0,
                                                                maximumFractionDigits: 0,
                                                            })} ({(getPersenRealisasi(dt.ru, dt.anggaran) * 100).toFixed(2)}%)
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            }
                                        </TableBody>
                                    </Table>
                                )
                        }
                    </CardContent>
                </Card>
            </ArgonBox>
        </ArgonBox>
    )
}

export default StrukturAnggaran